// extracted by mini-css-extract-plugin
export default {"projectHeader":"ProjectHeader_projectHeader__NCEfO","title":"ProjectHeader_title__Sncti"};